window.sq.config.themeSettings.topBarFilters = true;
function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.sq = window.sq || {};

// Grid Items Code
window.sq.showthreeItems = function () {
  let sqResult = document.querySelectorAll(".sq-results");
  let sqApp = document.querySelectorAll(".sq-app");
  if (sqResult && sqApp) {
    sqResult.forEach(e=>e.classList.add("sq-three-items"));
    sqResult.forEach(e=>e.classList.remove("sq-four-items"));
    sqApp.forEach(e=>e.classList.add("sq-three-items"));
    sqApp.forEach(e=>e.classList.remove("sq-four-items"));
  }
};

window.sq.showfourItems = function () {
   let sqResult = document.querySelectorAll(".sq-results");
  let sqApp = document.querySelectorAll(".sq-app");
  if (sqResult && sqApp) {
    sqResult.forEach(e=>e.classList.add("sq-four-items"));
    sqResult.forEach(e=>e.classList.remove("sq-three-items"));
    sqApp.forEach(e=>e.classList.add("sq-four-items"));
    sqApp.forEach(e=>e.classList.remove("sq-three-items"));
  }
};

window.sq.getStore = function (store) {
  store.filters.forEach((e) => {
    if (e.items && e.items.length > 0) {
    }
    if (e.items && e.items.length == 0) {
      setTimeout(() => {
        if (
          document.querySelector(
            ".sq-filter-group.sq-topbar .sq-filter-group-" + e.stFieldName
          )
        )
          document
            .querySelector(
              ".sq-filter-group.sq-topbar .sq-filter-group-" + e.stFieldName
            )
            .remove();
      }, 100);
    }
  });

  return true;
};

function toggleLayout(store) {
  console.log(store);
}

window.sq.initSearch = (store) => {
  store.search();
};

setTimeout(() => {
  if (document.querySelector(".sq-filter-main"))
    document.querySelector(".sq-filter-main").style.visibility = null;
  if (document.querySelector(".sparq-container"))
    document.querySelector(".sparq-container").style.visibility = null;
}, 200);
